import * as types from '../actions/settings/actionTypes'

const initState = { azure_maps_api_key: '' }

// TODO: Remove default export
// eslint-disable-next-line import/no-default-export
export default function settingsReducer(state = initState, action: any) {
  switch (action.type) {
    case types.SAVE_SETTINGS:
      return action.settings

    case types.GOOGLE_APIS_LOADED:
      return { ...state, googleApisLoaded: true }
    case types.AZURE_MAPS_API_LOADED:
      return { ...state, azureMapsApiLoaded: true }
    default:
      return state || initState
  }
}
